import { notification } from "antd";

export const notifyUser = (type, placement, BodyMessage) => {
  notification[type]({
    placement: placement,
    message: "Message",
    description: BodyMessage,
  });
};
